module.exports = __webpack_public_path__ + "static/katapult-front-2-fa24ed5b5bfbf86e51193d64a428f2c9.png";